import { globals } from "@/globals";
import translationEnUs from "@/translations/en-us.json";
import translationZhCn from "@/translations/zh-cn.json";
import translationZhTw from "@/translations/zh-tw.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const i18nResources = {
	"en-US": {
		translation: translationEnUs,
	},
	"zh-CN": {
		translation: translationZhCn,
	},
	"zh-TW": {
		translation: translationZhTw,
	},
};

export async function initI18n(
	lang?: keyof typeof i18nResources,
): Promise<void> {
	if (!lang) {
		const language = globals.params.lang;
		if (language && language in i18nResources) {
			lang = language as keyof typeof i18nResources;
		} else if (
			!navigator.language ||
			/^(yue|zh)(-cn|-sg|-hans(-[a-z]+)?)?$/i.test(navigator.language) ||
			(/bot|spider/i.test(navigator.userAgent) &&
				!navigator.userAgent.includes("Googlebot"))
		) {
			lang = "zh-CN";
		} else if (
			navigator.language.startsWith("zh") ||
			navigator.language.startsWith("yue")
		) {
			lang = "zh-TW";
		} else {
			lang = "en-US";
		}
	}

	await i18n.use(initReactI18next).init({
		fallbackLng: "en-US",
		interpolation: { escapeValue: false },
		lng: lang,
		resources: i18nResources,
	});
}
